/**
 * A press outside an open menu only closes it. Without this the same press
 * carries on to whatever it landed on — another pill's or row's click opens
 * THAT one's menu, a row starts a drag — so dismissing one menu opened the next.
 *
 * Call `swallowPress(ev)` from the menu's window `pointerdown` listener (capture)
 * once it has decided the press was outside and closed: the rest of that press
 * — its pointerdown, compat mousedown, up events, contextmenu and the click —
 * then reaches nothing. Focus and text selection are left alone.
 */

let swallowing = false;
let timer: number | null = null;

const EVENTS = ["mousedown", "pointerup", "mouseup", "contextmenu", "click", "auxclick"] as const;

function onEvent(ev: Event): void {
  if (!swallowing) return;
  ev.stopPropagation();
  if (ev.type === "click" || ev.type === "auxclick") {
    ev.preventDefault();
    stop();
  } else if (ev.type === "pointerup") {
    // A press that moved or was held may end in no click at all; don't eat the next one.
    if (timer !== null) window.clearTimeout(timer);
    timer = window.setTimeout(stop, 400);
  }
}

function stop(): void {
  swallowing = false;
  if (timer !== null) window.clearTimeout(timer);
  timer = null;
  for (const t of EVENTS) window.removeEventListener(t, onEvent, true);
  window.removeEventListener("pointercancel", stop, true);
}

export function swallowPress(ev: PointerEvent): void {
  ev.stopPropagation();
  stop();
  swallowing = true;
  for (const t of EVENTS) window.addEventListener(t, onEvent, true);
  window.addEventListener("pointercancel", stop, true);
}
